export default __webpack_public_path__ + "static/media/SNAPix_T_image_warning.e724f041.jpg";